import dynamic from 'next/dynamic'

export const SectionOfFaQs = dynamic(() => import('./section-of-faqs'))
